import React from "react";
import Button from "../atoms/Button/Button"; // Adjust the import based on your Button component location
import {
  ButtonContainer,
  ConfirmationIcon,
  ConfirmationMessage,
  ConfirmationModalWrapper,
  ConfirmationTitle,
} from "./styles";

interface ConfirmationModalProps {
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
  variant?: "primary" | "delete";
}

const ConfirmationModalContent: React.FC<ConfirmationModalProps> = ({
  message,
  onCancel,
  onConfirm,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  variant = "primary",
}) => {
  return (
    <ConfirmationModalWrapper>
      <ConfirmationTitle>
        <ConfirmationIcon />
        Confirm Action
      </ConfirmationTitle>
      <ConfirmationMessage>{message}</ConfirmationMessage>
      <ButtonContainer>
        <Button onClick={onCancel}>{cancelLabel}</Button>
        <Button onClick={onConfirm} variant={variant}>
          {confirmLabel}
        </Button>
      </ButtonContainer>
    </ConfirmationModalWrapper>
  );
};

export default ConfirmationModalContent;
